export const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export const DAYS_FORMAT_FOR_DATA_PICKER = 'YYYY MMM D';
export const DAYS_FORMAT = 'MMM D, YYYY';
export const DAYS_FORMAT_LONG = 'MMMM D, YYYY';
export const DAYS_FORMAT_WITH_TIME = 'MMM D, YYYY · HH:mm';
